import React, { useCallback, useEffect, useState } from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useAuth } from "../../Store/AuthContext";
import axios from "axios";
import APIDataFetchLoader from "../../Utils/APIDataFetchLoader";
import "./ProjectCss.css";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "admin/API/";

export default function ProjectDetails() {
  const { projectslug } = useParams();
  const navigate = useNavigate();
  const { RendomTokenfetch } = useAuth();
  const [projectDetails, setprojectDetails] = useState([]);
  const [multiImages, setmultiImages] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [ShowprojectDetails, setShowprojectDetails] = useState(true);

  const FetchProjectData = useCallback(async () => {
    setLoading(true);
    try {
      await axios
        .get(
          `${WebsiteAPIurl}projectDetailsAPI.php?projectslug=${projectslug}`,
          {
            headers: {
              Authorization: RendomTokenfetch,
            },
          }
        )
        .then((response) => {
          // console.log(response.data);
          if (response.data.status === "1") {
            setprojectDetails(response.data.projectdata);
            setmultiImages(response.data.multiImagesdata);
            // setShowprojectDetails(true);
          } else {
            setprojectDetails([]);
            setmultiImages([]);
            // setShowprojectDetails(false);
          }
        });
    } catch (error) {
      console.error("API Error:", error);
      navigate("/page-not-found", { replace: true });
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch, projectslug, navigate]);

  useEffect(() => {
    FetchProjectData();
  }, [FetchProjectData, projectslug]);

  if (loading) {
    return <APIDataFetchLoader />;
  }

  return (
    <>
      <Helmet>
        <title>{projectDetails.meta_title}</title>
        <meta name="description" content={projectDetails.meta_description} />
        <meta name="keywords" content={projectDetails.meta_keyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <Breadcrumb
        pagename={projectDetails?.title}
        mainpage={projectDetails?.catName}
      />
      <section className="propertie-section fix section-padding">
        <div className="container">
          <div className="propertie-details-wrapper">
            <div className="row g-4">
              <div className="col-lg-1"></div>
              <div className="col-lg-10">
                <div className="propertie-details-wrapper">
                  <div className="details-image">
                    <img
                      src={projectDetails.image}
                      alt={projectDetails.image_alt}
                      title={projectDetails.image_title}
                    />
                  </div>
                  <div className="row g-4 mt-3">
                    {projectDetails.image1 !== "" && (
                      <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                        <div className="details-image detailsImage">
                          <Link
                            to={projectDetails.image1}
                            data-fancybox="images"
                            data-caption=""
                          >
                            <img src={projectDetails.image1} alt="" />
                          </Link>
                        </div>
                      </div>
                    )}
                    {projectDetails.image2 !== "" && (
                      <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                        <div className="details-image detailsImage">
                          <Link
                            to={projectDetails.image2}
                            data-fancybox="images"
                            data-caption=""
                          >
                            <img src={projectDetails.image2} alt="" />
                          </Link>
                        </div>
                      </div>
                    )}
                    {projectDetails.image3 !== "" && (
                      <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                        <div className="details-image detailsImage">
                          <Link
                            to={projectDetails.image3}
                            data-fancybox="images"
                            data-caption=""
                          >
                            <img src={projectDetails.image3} alt="" />
                          </Link>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="details-content">
                    {projectDetails.location !== "" && (
                      <span className="location">
                        <i className="fa-solid fa-location-dot"></i>{" "}
                        {projectDetails.location}
                      </span>
                    )}
                    <h2>{projectDetails?.title || ""}</h2>
                    {projectDetails.tagline !== "" && (
                      <p className="mt-3">{projectDetails.tagline}</p>
                    )}
                    {projectDetails.sub_title !== "" && (
                      <span className="gt-box">{projectDetails.sub_title}</span>
                    )}
                    {projectDetails.description !== "" && (
                      <div
                        className="gt-list-content mb-0"
                        dangerouslySetInnerHTML={{
                          __html: projectDetails.description,
                        }}
                      ></div>
                    )}
                    <div className="list-items">
                      <h3 className="mb-3">Property Overview</h3>
                      <div className="row">
                        {projectDetails.inventory !== "" && (
                          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-3">
                            <div className="overviewBOX">
                              <p className="overviewTitle">
                                <i
                                  className="fa fa-file-text me-2"
                                  aria-hidden="true"
                                ></i>
                                {projectDetails.catslug === "plots"
                                  ? "Total Units"
                                  : "Total Inventory"}
                              </p>
                              <p>{projectDetails.inventory}</p>
                            </div>
                          </div>
                        )}

                        {projectDetails.year !== "" && (
                          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-3">
                            <div className="overviewBOX">
                              <p className="overviewTitle">
                                <i
                                  className="fa fa-calendar me-2"
                                  aria-hidden="true"
                                ></i>
                                Year
                              </p>
                              <p> {projectDetails.year}</p>
                            </div>
                          </div>
                        )}

                        {projectDetails.progress_status !== "" && (
                          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-3">
                            <div className="overviewBOX">
                              <p className="overviewTitle">
                                <i
                                  className="fa fa-retweet me-2"
                                  aria-hidden="true"
                                ></i>
                                Status
                              </p>
                              <p>{projectDetails.progress_status}</p>
                            </div>
                          </div>
                        )}

                        {projectDetails.area !== "" && (
                          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-3">
                            <div className="overviewBOX">
                              <p className="overviewTitle">
                                <i
                                  className="fa fa-area-chart me-2"
                                  aria-hidden="true"
                                ></i>
                                Carpet Area
                              </p>
                              <p> {projectDetails.area}</p>
                            </div>
                          </div>
                        )}

                        {projectDetails.pricing !== "" && (
                          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-3">
                            <div className="overviewBOX">
                              <p className="overviewTitle">
                                <i
                                  className="fa fa-inr me-2"
                                  aria-hidden="true"
                                ></i>
                                Pricing
                              </p>
                              <p> {projectDetails.pricing}</p>
                            </div>
                          </div>
                        )}

                        {/* 
                        {projectDetails.location !== "" && (
                           <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-3">
                          <div className="overviewBOX">
                            <p className="overviewTitle">
                              <i className="fa-solid fa-location-dot me-2"></i>
                              Location
                            </p>
                            <p> {projectDetails.location}</p>
                          </div>
                        </div>
                        )}
                      */}
                      </div>
                    </div>

                    {projectDetails.layoutsPlansImg !== "" && (
                      <div className="row mt-4">
                        <h3> Layout & Plans :</h3>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                          <div className="list-items-2 mt-3">
                            <div className="thumb">
                              <a
                                href={projectDetails.layoutsPlansImg}
                                data-fancybox="images"
                                data-caption=""
                              >
                                <img
                                  src={projectDetails.layoutsPlansImg}
                                  alt="img"
                                  width={"100%"}
                                />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="floor-plan-items">
                      <div className="tab-wrap">
                        <ul className="nav">
                          {projectDetails.legal_clearance !== "" && (
                            <li
                              className="nav-item wow fadeInUp"
                              data-wow-delay=".6s"
                            >
                              <a
                                href="#sixth"
                                data-bs-toggle="tab"
                                className="nav-link"
                              >
                                Legal Clearance
                              </a>
                            </li>
                          )}
                          {multiImages.length > 0 && (
                            <li
                              className="nav-item wow fadeInUp"
                              data-wow-delay=".4s"
                            >
                              <a
                                href="#Second"
                                data-bs-toggle="tab"
                                className="nav-link active"
                              >
                                Actual Property View
                              </a>
                            </li>
                          )}
                          {projectDetails.connectivity !== "" && (
                            <li
                              className="nav-item wow fadeInUp"
                              data-wow-delay=".6s"
                            >
                              <a
                                href="#fifth"
                                data-bs-toggle="tab"
                                className="nav-link"
                              >
                                Connectivity
                              </a>
                            </li>
                          )}
                          {projectDetails.project_highlight !== "" && (
                            <li
                              className="nav-item wow fadeInUp"
                              data-wow-delay=".6s"
                            >
                              <a
                                href="#Third"
                                data-bs-toggle="tab"
                                className="nav-link"
                              >
                                Project Highlights
                              </a>
                            </li>
                          )}
                          {projectDetails.amenities !== "" && (
                            <li
                              className="nav-item wow fadeInUp"
                              data-wow-delay=".6s"
                            >
                              <a
                                href="#Top"
                                data-bs-toggle="tab"
                                className="nav-link"
                              >
                                {projectDetails.catslug === "plots"
                                  ? "Plots Amenities"
                                  : "Building Amenities"}
                              </a>
                            </li>
                          )}
                        </ul>
                      </div>
                      <div className="tab-content">
                        {multiImages.length > 0 && (
                          <div
                            id="Second"
                            className="tab-pane fade show active"
                          >
                            <div className="row g-4 align-items-center">
                              {multiImages.map((imageValu, index) => (
                                <div className="col-lg-3 col-md-6" key={index}>
                                  <div className="thumb multiimagesProject">
                                    <Link
                                      to={imageValu.image}
                                      data-fancybox="images"
                                      data-caption=""
                                    >
                                      <img src={imageValu.image} alt="img" />
                                    </Link>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {projectDetails.project_highlight !== "" &&
                          typeof projectDetails.project_highlight ===
                            "string" && (
                            <div id="Third" className="tab-pane fade">
                              <div className="row g-4 align-items-center">
                                <div className="col-lg-12 col-md-12 mt-0">
                                  <div className="content">
                                    <div className="list-items-3 mt-0">
                                      <div className="list-wrap">
                                        <ul>
                                          {projectDetails.project_highlight
                                            .split(",")
                                            .map((item, index) => (
                                              <li key={index}>
                                                <i className="fa-solid fa-check-circle"></i>
                                                <b>{item.trim()}</b>
                                              </li>
                                            ))}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                        {projectDetails.amenities !== "" &&
                          typeof projectDetails.amenities === "string" && (
                            <div id="Top" className="tab-pane fade">
                              <div className="row g-4 align-items-center">
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-0">
                                  <div className="list-items-2">
                                    {/* <h3>Amenities :</h3> */}
                                    <ul>
                                      {projectDetails.amenities
                                        .split(",")
                                        .map((item, index) => (
                                          <li key={index}>
                                            <i className="fa-solid fa-check-circle"></i>
                                            <b>{item.trim()}</b>
                                          </li>
                                        ))}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                        {projectDetails.connectivity !== "" &&
                          typeof projectDetails.connectivity === "string" && (
                            <div id="fifth" className="tab-pane fade">
                              <div className="row">
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-0">
                                  <div className="list-items-2 mt-2">
                                    <h3>Connectivity :</h3>
                                    <ul>
                                      {projectDetails.connectivity
                                        .split(",")
                                        .map((item, index) => (
                                          <li key={index}>
                                            <i className="fa-solid fa-location-dot"></i>
                                            <b>{item.trim()}</b>
                                          </li>
                                        ))}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                        {projectDetails.legal_clearance !== "" &&
                          typeof projectDetails.legal_clearance ===
                            "string" && (
                            <div id="sixth" className="tab-pane fade">
                              <div className="row">
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-0">
                                  <div className="list-items-2 mt-2">
                                    <h3>Legal Clearance :</h3>
                                    <ul>
                                      {projectDetails.legal_clearance
                                        .split(",")
                                        .map((item, index) => (
                                          <li key={index}>
                                            <i className="fa-solid fa-check-circle"></i>
                                            <b>{item.trim()}</b>
                                          </li>
                                        ))}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-1"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
